module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av556-a8f7fbb2edc99df4e3cc53931c3d688b.jpg";